<template><div style="display:flex;align-items:center;justify-content:center;min-height:60vh;">
  <p v-if="!error">Iniciando sesión…</p>
  <div v-else><p>No fue posible iniciar sesión.</p><button @click="retry">Reintentar</button></div>
</div></template>
<script>
import { CognitoAuth } from '@/services/Auth/cognito';
export default {
  name: 'AuthCallback', data: () => ({ error: false }),
  async mounted(){ try{ const u = await CognitoAuth.handleCallback(); this.$router.replace((u && u.state && u.state.from) || '/'); }catch(e){ console.error('Callback:', e); this.error = true; } },
  methods: { retry(){ CognitoAuth.login({ from: '/' }); } },
};
</script>